import React from 'react';
const EmptyArchiveIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 8L4.84717 18.1661C4.93356 19.2027 5.80009 20 6.84027 20H17.1597C18.1999 20 19.0664 19.2027 19.1528 18.1661L20 8M4 8H20M4 8H3C2.44772 8 2 7.55228 2 7V5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V7C22 7.55228 21.5523 8 21 8H20M14 12L12 14M12 14L10 16M12 14L10 12M12 14L14 16" stroke="#0A25FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export {EmptyArchiveIcon};